// extracted by mini-css-extract-plugin
export default {"content":"Note-module__content__6Ja2k","text":"Note-module__text__PeRvl"};